import React, { PureComponent, Fragment } from 'react';
import { Root } from './Timesheet.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, Tabs, Tab, TableFooter, TablePagination, Collapse, TextField } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from '../Timesheet/components/SideList'
import Timer from '../Timesheet/components/Timer'
import Search from '@material-ui/icons/Search'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http'
import ExpandMore from '@material-ui/icons/ExpandMore';
import { roleStr, roleName, roleInfo, defaultPageSize, ADD, EDIT, VIEW } from '../../common/common';
import { timeFormat } from '../../common/utils';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'
import TimesheetInfo from '../Timesheet/components/TimesheetInfo';
import { withRouter } from 'react-router-dom';

const ADMIN = "admin";
const DEPT = "dept_manager";
const TEAM = "team_leader";
const STAFF = "staff";
const TIME_EDIT = "time_edit";
const TIME_FAIL = "time_fail";
const TIME_SUCCESS = "time_success";
const INDIVIDUAL = "individual";
const GROUP = "group";
const MAIN = "main";
class Timesheet extends PureComponent {
    constructor(props) {
        super(props);
        const initDate = this.initDate();
        this.state = {
            membersData: [],
            open: false,
            expanded: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            totalUser: [],
            tabArr: [],
            tabIndex: 0,
            client_id: 0,
            timesheetUserData: [],
            timesheetData: [],
            timeCreateState: TIME_EDIT,
            tabObj: null,
            handler_id: 0,
            statisticData: [],
            filterState: "",
            matter_name: "",
            matter_number: "",
            matter_note: "",

            fromDate: initDate.from,
            toDate: initDate.to,
            otherFromDate: "",
            otherToDate: "",
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
            sideObj: null,

            personAdmin: "",
            personBillable: "",

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,
        }
        this.handleCreateTimesheet = this.handleCreateTimesheet.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleViewDetail = this.handleViewDetail.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleTimer = this.handleTimer.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleUserChangePage = this.handleUserChangePage.bind(this);
        this.handleUserChangeRowsPerPage = this.handleUserChangeRowsPerPage.bind(this);
        this.handleClickLink = this.handleClickLink.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleOtherDateChange = this.handleOtherDateChange.bind(this);
    }
    render() {
        const {
            membersData,
            open,
            expanded,
            dialogTitle,
            dialogData,
            dialogState,
            tabIndex,
            tabObj,
            stateRight,
            timesheetUserData,
            timesheetData,
            page_index,
            page_size,
            total_items,
            showToast,
            toastMsg,
            toastState,
            showAlert,
            fromDate,
            toDate,
            otherFromDate,
            otherToDate,
            timeCreateState,
            tabArr,
            sideObj,
            statisticData,
            filterState,
            personAdmin,
            personBillable,
        } = this.state;
        const filtersView = () => {
            if (roleName === ADMIN) {
                return <Button
                    className="bgW btn"
                    variant="contained"
                    onClick={e => this.handleDrawer(e, true)}>
                    Show Filters
                </Button>
            }
        }
        // const delBtn = (row) => {
        //     if (roleName === ADMIN) {
        //         return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
        //     }
        // }
        const tablecellName = () => {
            if (filterState === GROUP) {
                return <Fragment>
                    <TableCell className="cell">Total Billable Hour</TableCell>
                    <TableCell className="cell">Total Admin Hour</TableCell>
                </Fragment>
            } else {
                return <TableCell className="cell">Others</TableCell>
            }
        }
        const tablecellValue = (row, type) => {
            if (filterState === GROUP) {
                return <Fragment>
                    <TableCell>{this.changeHour(row.total_billable_hours)}</TableCell>
                    <TableCell>{this.changeHour(row.total_admin_hours)}</TableCell>
                </Fragment>
            } else if (type === "viewDetail") {
                return <TableCell>
                    <div className="h h-l">
                        <Button variant="outlined" color="primary" onClick={e => this.handleViewDetail(e, row)}>View Detail</Button>
                        {/* {delBtn(row)} */}
                    </div>
                </TableCell>
            } else if (type === "edit") {
                return <TableCell>
                    <div className="h h-l">
                        <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                        <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                        {/* {delBtn(row)} */}
                        <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                    </div>
                </TableCell>
            }
        }
        const totalTimeView = () => {
            if (statisticData.length > 0) {
                return <div className="textWapper f">
                    <div className="title">Total</div>
                    <div className="time">{this.totalTime(statisticData)}</div>
                </div>
            }
        }
        const groupView = () => {
            if (filterState === GROUP) {
                return <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell className="cell">Name</TableCell>
                            <TableCell className="cell">Email</TableCell>
                            <TableCell className="cell">Office</TableCell>
                            <TableCell className="cell">Department</TableCell>
                            <TableCell className="cell">Team</TableCell>
                            {tablecellName()}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {timesheetData.map((row, index) => (
                            <TableRow key={index} role="checkbox">
                                <TableCell>{this.tableData(row, "name")}</TableCell>
                                <TableCell>{this.tableData(row, "email")}</TableCell>
                                <TableCell>{this.tableData(row, "office")}</TableCell>
                                <TableCell>{this.tableData(row, "dept")}</TableCell>
                                <TableCell>{this.tableData(row, "team")}</TableCell>
                                {tablecellValue(row, "viewDetail")}
                            </TableRow>
                        ))}
                        {timesheetData.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 75]}
                                colSpan={12}
                                count={total_items}
                                page={timesheetData.length === 0 ? 0 : page_index - 1}
                                rowsPerPage={page_size}
                                SelectProps={{
                                    inputProps: { 'arialabel': 'Rows per page' },
                                    native: true,
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            } else {
                console.log("timesheet", timesheetData)
                return <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell className="cell">First Name</TableCell>
                            <TableCell className="cell">Last Name</TableCell>
                            <TableCell className="cell">Email</TableCell>
                            <TableCell className="cell">Phone</TableCell>
                            {tablecellName()}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {timesheetUserData.map((row) => {
                            //updated on 5/8/25, some rows of raw data is null
                            if(row){
                                return (                               
                                    <TableRow key={row.id} role="checkbox">
                                        <TableCell component="th" scope="row">
                                            {this.tableUserData(row, "fname")}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {this.tableUserData(row, "lname")}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {this.tableUserData(row, "email")}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {this.tableUserData(row, "phone")}
                                        </TableCell>
                                        {tablecellValue(row, "viewDetail")}
                                    </TableRow>
                                );                   
                            }                                        
                                         
                        })}
                        {timesheetUserData.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 75]}
                                colSpan={12}
                                count={total_items}
                                page={timesheetUserData.length === 0 ? 0 : page_index - 1}
                                rowsPerPage={page_size}
                                SelectProps={{
                                    inputProps: { 'arialabel': 'Rows per page' },
                                    native: true,
                                }}
                                onChangePage={this.handleUserChangePage}
                                onChangeRowsPerPage={this.handleUserChangeRowsPerPage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            }
        }
        const myTimesheetView = () => {
            return <Fragment>
                <div className="tableTool h">
                    <div>From</div>
                    <TextField
                        id="date"
                        type="date"
                        variant="outlined"
                        className="textDateField"
                        value={fromDate}
                        onChange={e => this.handleDateChange(e, 'fromDate')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            style: {
                                height: 1,
                            },
                        }}
                    />
                    <div>To</div>
                    <TextField
                        id="date"
                        type="date"
                        variant="outlined"
                        className="textDateField"
                        value={toDate}
                        onChange={e => this.handleDateChange(e, 'toDate')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            style: {
                                height: 1,
                            },
                        }}
                    />
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search by Matter Name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'matter_name')}
                        />
                    </div>
                    {statisticData.map(row => (
                        <div className="textWapper f">
                            <div className="title">{row.hours_type}</div>
                            <div className="time">{row.total_hours}</div>
                        </div>
                    ))}
                </div>
                <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell className="cell">Date</TableCell>
                            <TableCell className="cell">Case Number</TableCell>
                            <TableCell className="cell">Matter Number</TableCell>
                            <TableCell className="cell">Notes</TableCell>
                            <TableCell className="cell">Task Type</TableCell>
                            <TableCell className="cell">Hours</TableCell>
                            {tablecellName()}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {timesheetData.map(row => (
                            <TableRow key={row.id} role="checkbox">
                                <TableCell>{timeFormat(row.date)}</TableCell>
                                <TableCell component="th" scope="row">
                                    {row.matter && row.matter[0].case ? row.matter[0].case.number : ""}
                                </TableCell>
                                <TableCell>{row.matter && row.matter[0] ? row.matter[0].number : ""}</TableCell>
                                <TableCell>{row.note}</TableCell>
                                <TableCell>{row.hours_type}</TableCell>
                                <TableCell>{this.changeHour(row.hours)}</TableCell>
                                {tablecellValue(row, "edit")}
                            </TableRow>
                        ))}
                        {timesheetData.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[25, 50, 75]}
                                colSpan={12}
                                count={total_items}
                                page={timesheetData.length === 0 ? 0 : page_index - 1}
                                rowsPerPage={page_size}
                                SelectProps={{
                                    inputProps: { 'arialabel': 'Rows per page' },
                                    native: true,
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </Fragment>
        }
        const showTabPanel = () => {
            if (tabIndex === 0) {//all or my
                if (roleName === ADMIN || roleName === DEPT || roleName === TEAM) {//all
                    return <Paper className="tableWapper">
                        <div className="tableTool h">
                            {filtersView()}
                            {totalTimeView()}
                            {membersData.map((row, index) => (
                                <div className="textWapper f" key={index}>
                                    <div className="title">{row.hours_type}</div>
                                    <div className="time">{this.changeTimeToSMH(row.total_hours)}</div>
                                </div>
                            ))}
                        </div>
                        {groupView()}
                    </Paper>
                } else {//my
                    return <Paper className="tableWapper">
                        {myTimesheetView()}
                    </Paper>
                }
            } else {//my or other
                if ((tabIndex === 1 && roleName === DEPT) || (tabIndex === 1 && roleName === TEAM)) {//my
                    return <Paper className="tableWapper">
                        {myTimesheetView()}
                    </Paper>
                } else {//other
                    return <Paper className="tableWapper">
                        <div className="tableTool h">
                            <div className="userInfo h">
                                <div className="userImg"></div>
                                <div className="userText">
                                    <div className="name">{tabObj.first_name} {tabObj.last_name}</div>
                                    {/* <div className="business">Business Attorney</div> */}
                                    <div className="email">{tabObj.email}</div>
                                </div>
                                <div className="h">
                                    <div>From</div>
                                    <TextField
                                        id="date"
                                        type="date"
                                        variant="outlined"
                                        className="textDateField"
                                        value={otherFromDate}
                                        onChange={e => this.handleOtherDateChange(e, 'otherFromDate')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            style: {
                                                height: 1,
                                            },
                                        }}
                                    />
                                    <div>To</div>
                                    <TextField
                                        id="date"
                                        type="date"
                                        variant="outlined"
                                        className="textDateField"
                                        value={otherToDate}
                                        onChange={e => this.handleOtherDateChange(e, 'otherToDate')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            style: {
                                                height: 1,
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="searchWapper h m-20">
                                <div className="search c">
                                    <Search />
                                </div>
                                <InputBase
                                    placeholder="Search by Matter Name"
                                    className="bgW"
                                    inputProps={{ 'aria-label': 'Search' }}
                                    onChange={e => this.handleSearch(e, 'matter_name')}
                                />
                            </div>
                            <div className="textWapper f">
                                <div className="title">TOTAL</div>
                                <div className="time">{this.changeTimeToSMH(personAdmin, personBillable)}</div>
                            </div>
                            <div className="textWapper f">
                                <div className="title">BILLABLE</div>
                                <div className="time">{this.changeTimeToSMH(personBillable)}</div>
                            </div>
                            <div className="textWapper f">
                                <div className="title">ADMIN</div>
                                <div className="time">{this.changeTimeToSMH(personAdmin)}</div>
                            </div>
                        </div>
                        <Table stickyHeader className="table">
                            <TableHead>
                                <TableRow role="checkbox">
                                    <TableCell className="cell">Date</TableCell>
                                    <TableCell className="cell">Case Number</TableCell>
                                    <TableCell className="cell">Matter Number</TableCell>
                                    <TableCell className="cell">Matter Name</TableCell>
                                    <TableCell className="cell">Notes</TableCell>
                                    <TableCell className="cell">Task Type</TableCell>
                                    <TableCell className="cell">Hours</TableCell>
                                    {tablecellName()}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {timesheetData.map(row => (
                                    <TableRow key={row.id} role="checkbox">
                                        <TableCell>{timeFormat(row.date)}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.matter ? row.matter[0].case.number : "--"}
                                        </TableCell>
                                        <TableCell>{row.matter ? row.matter[0].number : "--"}</TableCell>
                                        <TableCell>{row.matter ? row.matter[0].name : "--"}</TableCell>
                                        <TableCell>{row.note}</TableCell>
                                        <TableCell>{row.hours_type}</TableCell>
                                        <TableCell>{this.changeHour(row.hours)}</TableCell>
                                        {tablecellValue(row, "edit")}
                                    </TableRow>
                                ))}
                                {timesheetData.length === 0 && (
                                    <TableRow style={{ height: 300 }}>
                                        <TableCell colSpan={12} />
                                    </TableRow>
                                )}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[25, 50, 75]}
                                        colSpan={12}
                                        count={total_items}
                                        page={timesheetData.length === 0 ? 0 : page_index - 1}
                                        rowsPerPage={page_size}
                                        SelectProps={{
                                            inputProps: { 'arialabel': 'Rows per page' },
                                            native: true,
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </Paper>
                }
            }
        }
        const timerInfo = () => {
            if (timeCreateState === TIME_EDIT) {
                return <Timer
                    handleTimer={this.handleTimer}
                />
            } else if (timeCreateState === TIME_FAIL) {
                return <div className="created c">
                    <div className="failIcon"></div>
                    <div className="title1">Sorry, the timesheet you created had already existed!</div>
                    <div className="title2">
                        <span className="link" onClick={e => this.handleClickLink(e, 'list')}>Go to My Timesheet List</span>
                        <span> to edit or </span>
                        <span className="link" onClick={e => this.handleClickLink(e, 'return')}>Return to Add Another Time</span>
                    </div>
                </div>
            } else if (timeCreateState === TIME_SUCCESS) {
                return <div className="created c">
                    <div className="successIcon"></div>
                    <div className="title1">The time has successfully added to your timesheet!</div>
                    <div className="title2">
                        <span>Return to </span>
                        <span className="link" onClick={e => this.handleClickLink(e, 'return')}>Add Another Time</span>
                        <span> or </span>
                        <span className="link" onClick={e => this.handleClickLink(e, 'list')}>Go to My Timesheet List</span>
                    </div>
                </div>
            }
        }
        return (
            <Root>
                <div className="head">
                    <div className="h h-b">
                        <PageTitle title="All Timesheet" subtitle="MANAGEMENT"></PageTitle>
                        <div className="f h h-r">
                            <div className={expanded ? "expandBtn h h-c" : "expandBtnOpen h h-c"} onClick={this.handleCreateTimesheet}>
                                CREATE TIMESHEET
                            <ExpandMore className={expanded ? "iconExpand" : "iconExpandOpen"} />
                            </div>
                        </div>
                    </div>
                    <Collapse className="extend" in={expanded} timeout="auto" unmountOnExit>
                        {timerInfo()}
                    </Collapse>
                </div>
                <Tabs
                    value={tabIndex}
                    className="tabs"
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChangeTab}
                    aria-label="disabled tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    {tabArr.map((row, index) => (
                        <Tab key={index} className={tabIndex === tabArr.indexOf(row) ? "tabSelect" : "tab"} label={row.name} />
                    ))}
                </Tabs>
                {showTabPanel()}
                <Dialog maxWidth={false} open={open}>
                    <TimesheetInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                    />
                </Dialog>
                <Drawer anchor="right" open={stateRight} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                            data={sideObj}
                        ></SideList>
                    </div>
                </Drawer>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this timesheet?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        if (roleName === ADMIN) {
            this.getTimesheetUsers();
            this.setState(() => ({
                tabArr: [{ name: "All Timesheet" }]
            }))
        } else if (roleName === DEPT || roleName === TEAM) {
            this.getTimesheetUsers();
            this.setState(() => ({
                tabArr: [
                    { name: "All Timesheet" },
                    { name: "My Timesheet" }
                ]
            }))
        } else {
            this.getTimesheets();
            this.setState(() => ({
                tabArr: [{ name: "My Timesheet" }]
            }))
        }
    }
    getTimesheetUsers() {
        const {
            page_index,
            page_size,
        } = this.state;
        let params = {
            page_index,
            page_size
        }
        this.getTimesheetUser(params);
    }
    getTimesheets() {
        const {
            tabIndex,
            fromDate,
            toDate,
            otherFromDate,
            otherToDate,
            matter_name,
            matter_note,
            handler_office,
            handler_id,
            handler_team_id,
            handler_department_id,
            page_index,
            page_size,
        } = this.state;
        let handler_id_copy = handler_id;
        if (roleName === STAFF) handler_id_copy = roleInfo.identity.id;
        let start_date = null;
        let end_date = null;
        if (tabIndex === 0) {//all or my
            if (roleName === ADMIN || roleName === DEPT || roleName === TEAM) {//all
                start_date = null;
                end_date = null;
            } else {//my
                start_date = (fromDate && toDate) ? (Date.parse(new Date(fromDate)) / 1000) : null;
                end_date = (fromDate && toDate) ? (Date.parse(new Date(toDate)) / 1000) : null;
            }
        } else {//my or other
            if ((tabIndex === 1 && roleName === DEPT) || (tabIndex === 1 && roleName === TEAM)) {//my
                start_date = (fromDate && toDate) ? (Date.parse(new Date(fromDate)) / 1000) : null;
                end_date = (fromDate && toDate) ? (Date.parse(new Date(toDate)) / 1000) : null;
            } else {//other
                start_date = (otherFromDate && otherToDate) ? (Date.parse(new Date(otherFromDate)) / 1000) : null;
                end_date = (otherFromDate && otherToDate) ? (Date.parse(new Date(otherToDate)) / 1000) : null;
            }
        }
        let params = {
            start_date,
            end_date,
            matter_name: matter_name ? matter_name : null,
            matter_note: matter_note ? matter_note : null,
            handler_office: handler_office ? handler_office : null,
            handler_id: handler_id_copy ? handler_id_copy : null,
            handler_team_id: handler_team_id ? handler_team_id : null,
            handler_department_id: handler_department_id ? handler_department_id : null,
            page_index,
            page_size
        }
        this.getTimesheet(params);
    }

    getStatisticTimesheet(team_id) {
        const {
            start_date,
            end_date,
        } = this.state;
        let params = {
            start_date,
            end_date,
        }
        this.statisticTimesheet(team_id, params);
    }
    getStatisticMembers(team_id) {
        const {
            start_date,
            end_date,
            page_index,
            page_size,
        } = this.state;
        let params = {
            start_date,
            end_date,
            page_index,
            page_size
        }
        console.log("======team_id====", team_id)
        this.statisticMembers(team_id, params, (res) => {
            const timesheetData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log("--------", timesheetData);
            this.setState(() => ({
                timesheetData,
                page_size,
                total_items
            }))
        });
    }
    //tab选项卡
    handleChangeTab(e, newValue) {
        const { tabArr, handler_id } = this.state;
        let tabIndex = newValue;
        let handler_id_copy = handler_id;
        const tabObj = tabArr[tabIndex].data;
        console.log("--handler_id_copy---", handler_id_copy);
        if (roleName === ADMIN) {//all/other
            if (tabIndex === 0) {
                handler_id_copy = null;
            } else {
                handler_id_copy = tabObj.id;
            }
        } else if (roleName === DEPT || roleName === TEAM) {//all/my/other
            if (tabIndex === 0) {
                handler_id_copy = null;
            } else if (tabIndex === 1) {
                handler_id_copy = roleInfo.identity.id;
            } else {
                handler_id_copy = tabObj.id;
            }
        } else if (roleName === STAFF) {//my
            if (tabIndex === 0) {
                handler_id_copy = roleInfo.identity.id;
            }
        }
        this.setState({
            handler_id: handler_id_copy,
            tabIndex,
            tabObj,
            page_index: 1,
            page_size: defaultPageSize
        }, () => {
            if (roleName !== STAFF && tabIndex === 0) {
                this.getTimesheetUsers();
            } else {
                this.getTimesheets();
            }
        })
    }
    handleDateChange(e, name) {
        const value = e.target.value;
        const { fromDate, toDate } = this.state;
        let fromDateStamp = new Date(fromDate).getTime();
        let toDataStamp = new Date(toDate).getTime();
        let valueDateStamp = new Date(value).getTime();
        if (name === "fromDate") {
            if (valueDateStamp > toDataStamp) {
                this.setState({
                    [name]: value,
                    toDate: value
                }, () => {
                    this.getTimesheets();
                })
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getTimesheets();
                })
            }
        } else if (name === "toDate") {
            if (valueDateStamp < fromDateStamp) {
                this.showToast("The selected time cannot be earlier than the from time", "warning");
                return;
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getTimesheets();
                })
            }
        }
    }
    handleOtherDateChange(e, name) {
        const value = e.target.value;
        this.setState({
            [name]: value
        }, () => {
            this.getTimesheets();
        })
    }
    handleTimer(obj) {
        this.addTimesheet(obj);
    }
    handleCreateTimesheet() {
        const { expanded } = this.state;
        this.setState(() => ({
            expanded: !expanded
        }))
    }
    handleViewDetail(e, obj) {
        const { tabArr } = this.state;
        const id = obj.id;
        const team_id = obj.handler_department ? obj.handler_department.team.id : "";
        const name = obj.first_name + " " + obj.last_name;
        let [...tabArrCopy] = tabArr;
        let tabIndex = 0;
        let haveObj = false;
        const tabObjValue = {
            id,
            name,
            data: obj
        }
        for (const obj of tabArrCopy) {
            if (obj.id === id) {
                haveObj = true;
                tabIndex = tabArrCopy.indexOf(obj);
                break;
            }
        }
        if (!haveObj) {
            tabArrCopy.push(tabObjValue);
            tabIndex = tabArrCopy.indexOf(tabObjValue);
        }
        this.setState({
            tabIndex,
            tabArr: tabArrCopy,
            tabObj: obj,
            handler_id: id
        }, () => {
            this.getTimesheets();
            if (team_id && team_id !== "") this.getPersonStatistic(id, team_id);
        })
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj,
        }))
        this.openDialog("VIEW TIMESHEET", VIEW);
    }
    handleEdit(e, obj) {
        const client_id = obj.id;
        this.setState(() => ({
            dialogData: obj,
            client_id,
        }))
        this.openDialog("EDIT TIMESHEET", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }));
    }
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleCreate(obj) {
        const { dialogState, dialogData } = this.state;
        if (dialogState === EDIT) {
            let tm_id = dialogData.id;
            this.editTimesheet(tm_id, obj);
        }
    }
    handleDrawer(e, open) {
        this.setState(() => ({
            stateRight: open
        }));
    };
    handleApply(obj) {
        console.log("-----=======---", obj)
        const state = obj.state;
        const start_date = obj.start_date;
        const end_date = obj.end_date;
        const handler_office = obj.office;
        const handler_id = obj.member_id;
        const handler_team_id = obj.team_id;
        const handler_department_id = obj.department_id;
        if (state === INDIVIDUAL) {
            this.setState({
                filterState: state,
                statisticData: [],
                timesheetData: [],
                handler_office: handler_office ? handler_office : null,
                handler_id: handler_id ? handler_id : null,
                handler_team_id: handler_team_id ? handler_team_id : null,
                handler_department_id: handler_department_id ? handler_department_id : null,
                page_index: 1,
                stateRight: false,
                sideObj: obj
            }, () => {
                this.getTimesheets();
            })
        } else if (state === GROUP) {
            this.setState({
                filterState: state,
                statisticData: [],
                timesheetData: [],
                start_date,
                end_date,
                page_index: 1,
                stateRight: false,
                sideObj: obj
            }, () => {
                this.getStatisticTimesheet(handler_team_id);
                this.getStatisticMembers(handler_team_id);
            })
        } else if (state === MAIN) {
            this.setState({
                filterState: state,
                statisticData: [],
                timesheetData: [],
                handler_office: null,
                handler_id: null,
                handler_team_id: null,
                handler_department_id: null,
                page_index: 1,
                stateRight: false,
                sideObj: obj
            }, () => {
                this.getTimesheets();
            })
        }
    }
    handleUserChangePage(e, newPage) {
        console.log(newPage + 1)
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getTimesheetUsers();
        })
    }
    handleUserChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getTimesheetUsers();
        });
    }
    handleChangePage(e, newPage) {
        console.log(newPage + 1)
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getTimesheets();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getTimesheets();
        });
    }
    handleSearch(e, name) {
        const value = e.target.value;
        console.log([name])
        this.setState({
            [name]: value
        }, () => {
            this.getTimesheets();
        })
    }
    handleClickLink(e, name) {
        const { expanded } = this.state;
        if (name === "list") {
            let tabIndex = 0;
            if (roleName === DEPT || roleName === TEAM) {
                tabIndex = 1;
            }
            this.setState(() => ({
                tabIndex,
                expanded: !expanded,
                timeCreateState: TIME_EDIT
            }));
        } else if (name === "return") {
            this.setState(() => ({
                timeCreateState: TIME_EDIT
            }));
        }
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        const { dialogData } = this.state;
        console.log(dialogData)
        console.log(dialogData.id)
        this.delTimesheet(dialogData.id);
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
        }));
    }
    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }
    originAttorneyName(obj) {
        if (obj) {
            return obj.username;
        } else {
            return "";
        }
    }
    filterIIncludeArr(arr, value, name) {
        let newArr = [];
        for (let obj of arr) {
            if (name === "name") {
                console.log(obj)
                if (obj.individual.first_name.includes(value) || obj.individual.last_name.includes(value)) {
                    newArr.push(obj);
                }
            } else if (name === "email") {
                if (obj.individual.email.includes(value)) {
                    newArr.push(obj);
                }
            }
        }
        return newArr;
    }
    filterCIncludeArr(arr, value, name) {
        let newArr = [];
        for (let obj of arr) {
            if (name === "name") {
                if (obj.corporation.name.includes(value)) {
                    newArr.push(obj);
                }
            }
        }
        return newArr;
    }
    changeTimeToSMH(count, plusNum = 0) {
        let s = parseInt(count) + parseInt(plusNum);
        if (!Number.isNaN(s)) {
            const timeS = this.showNum(s % 60);
            const timeM = this.showNum(parseInt(s / 60) % 60);
            const timeH = this.showNum(parseInt(s / 60 / 60));
            return timeH + ":" + timeM + ":" + timeS;
        } else {
            return "--";
        }
    }
    showNum(num) {
        if (num < 10) {
            return '0' + num
        }
        return num
    }
    tableUserData(row, name) {
        let results = "";
        switch (name) {
            case "name":
                const firstName = row.first_name ? row.first_name : "--";
                const lastName = row.last_name ? row.last_name : "--";
                results = firstName + " " + lastName;
                break;
            case "fname":
                results = row.first_name ? row.first_name : "--";
                break;
            case "lname":
                results = row.last_name ? row.last_name : "--";
                break;
            case "email":
                results = row.email ? row.email : "--";
                break;
            case "phone":
                results = row.phone ? row.phone : "--";
                break;
            default:
                break;
        }
        return results;
    }
    tableData(row, name) {
        const { filterState } = this.state;
        let results = "";
        if (filterState !== GROUP) {
            switch (name) {
                case "name":
                    const firstName = row.handler.first_name ? row.handler.first_name : "--";
                    const lastName = row.handler.last_name ? row.handler.last_name : "--";
                    results = firstName + " " + lastName;
                    break;
                case "fname":
                    results = row.handler.first_name ? row.handler.first_name : "--";
                    break;
                case "lname":
                    results = row.handler.last_name ? row.handler.last_name : "--";
                    break;
                case "email":
                    results = row.handler.email ? row.handler.email : "--";
                    break;
                case "phone":
                    results = row.handler.phone ? row.handler.phone : "--";
                    break;
                case "office":
                    results = row.handler_department ? row.handler_department.office : "--";
                    break;
                case "dept":
                    results = row.handler_department ? row.handler_department.name : "--";
                    break;
                case "team":
                    results = row.handler_department ? row.handler_department.team.name : "--";
                    break;
                default:
                    break;
            }
        } else {
            switch (name) {
                case "name":
                    results = row.member.first_name + " " + row.member.last_name;
                    break;
                case "email":
                    results = row.member.email ? row.member.email : "--";
                    break;
                case "office":
                    results = row.member.office ? row.member.office : "--";
                    break;
                case "dept":
                    results = row.team ? row.team.dept_info.name : "--";
                    break;
                case "team":
                    results = row.team ? row.team.name : "--";
                    break;
                default:
                    break;
            }
        }
        return results;
    }
    totalTime(arr) {
        let total = 0;
        for (const obj of arr) {
            total += obj.total_hours;
        }
        return this.changeTimeToSMH(total);
    }
    changeHour(s, plusNum = 0) {
        let totalS = parseInt(s) + parseInt(plusNum);
        if (totalS) {
            return Math.floor(((totalS + 35) / 3600) * 100) / 100;
        } else {
            return 0;
        }
    }
    initDate() {
        const date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth(),
            from = new Date(y, m, 1),
            to = new Date(y, m + 1, 0);
        return {
            from: this.formatDay(from),
            to: this.formatDay(to)
        }
    }
    formatDay(date) {
        var d = date;
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        return d.getFullYear() + "-" + (month) + "-" + (day);
    }
    getPersonStatistic(id, team_id) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        this.statisticMembers(team_id, params, (res) => {
            const timesheetData = res.data.data;
            let personAdmin = "";
            let personBillable = "";
            for (const obj of timesheetData) {
                if (obj.member.id === id) {
                    personAdmin = obj.total_admin_hours;
                    personBillable = obj.total_billable_hours;
                }
            }
            this.setState(() => ({
                personAdmin,
                personBillable
            }))
        });
    }
    //---------------request---------------
    getTimesheetUser(params) {
        instance.get(BASE_URL + roleStr() + '/timesheet/users', { params }).then((res) => {
            const timesheetUserData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            this.setState(() => ({
                timesheetUserData,
                page_size,
                total_items
            }))
        })
    }
    getTimesheet(params) {
        instance.get(BASE_URL + roleStr() + '/timesheet', { params }).then((res) => {
            const timesheetData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            // const newTimesheetData = deduplicationObjArr2(timesheetData, "handler", "id")
            console.log(timesheetData);
            this.setState(() => ({
                timesheetData,
                page_size,
                total_items
            }))
        })
    }
    addTimesheet(obj) {
        const params = {
            note: obj.note,
            date: obj.date,
            hours: obj.hours,
            hours_type: obj.hours_type,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id,
            handler_department_id: obj.handler_department_id,
        };

        if (obj.has_matter) {
            params['matter_id'] = obj.matter_id;
        }

        instance.post(BASE_URL + roleStr() + '/timesheet', params).then((res) => {
            console.log(res);
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getTimesheets();
            this.setState(() => ({
                timeCreateState: TIME_SUCCESS
            }))
        }).catch((err) => {
            this.setState(() => ({
                timeCreateState: TIME_FAIL
            }));
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    editTimesheet(tm_id, obj) {
        const params = {
            note: obj.note,
            date: obj.date,
            hours: obj.hours,
            hours_type: obj.hours_type,
            // handler_id: obj.handler_id,
            // handler_team_id: obj.handler_team_id,
            // handler_department_id: obj.handler_department_id,
        }
        if (obj.has_matter) {
            params['matter_id'] = obj.matter_id;
        }
        instance.put(BASE_URL + roleStr() + '/timesheet/' + tm_id, params).then((res) => {
            console.log(res)
            this.showToast("Successfully modified", "success");
            this.closeDialog();
            this.getTimesheets();
            this.setState(() => ({
                tabIndex: 0
            }));
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delTimesheet(tm_id) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.delete(BASE_URL + role + '/timesheet/' + tm_id).then((res) => {
            console.log(res)
            this.showToast("Successfully deleted", "success");
            this.getTimesheets();
        }).catch((err) => {
            const errorCode = err.response.data.error;
            if (errorCode === 3000) {
                this.showToast("Failed to delete, the timesheet has been used", "error");
            }
        })
    }
    statisticTimesheet(team_id, params) {
        instance.get(BASE_URL + 'statistic/timesheet/' + team_id, { params }).then((res) => {
            console.log(res.data.data)
            const statisticData = res.data.data
            this.setState(() => ({
                statisticData
            }));
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    statisticMembers(team_id, params, callback) {
        console.log("===sssssmmm====", team_id)
        instance.get(BASE_URL + 'statistic/timesheet/' + team_id + "/members", { params }).then((res) => {
            callback(res);
        })
    }
}

export default withRouter(Timesheet);